// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import hrEntity from './entities/hr.json';
import hrMenu from '../pages/hr/menu.json';
import hrFullForm from '../pages/hr/forms/full.json';
import hrContextForm from '../pages/hr/forms/context.json';
import hrMiniForm from '../pages/hr/forms/mini.json';
import hrLookupForm from '../pages/hr/forms/lookup.json';
import hrTableView from '../pages/hr/views/table.json';
import hrStagesView from '../pages/hr/views/stages.json';
import hrCardsView from '../pages/hr/views/cards.json';
import hrInlineView from '../pages/hr/views/inline.json';
import hrBacklogView from '../pages/hr/views/backlog.json';
import hrSplitView from '../pages/hr/views/split.json';
import hrCalendarView from '../pages/hr/views/calendar.json';
import hrDashboardView from '../pages/hr/views/dashboard.json';

/** Тип запису «Кадровий запит» зі сторінками пакета: меню, форми та подання з pages/hr/. */
export const hrDefinition: IRecordTypeDefinition = {
  ...hrEntity,
  views: assembleViewSet({
      table: hrTableView,
      stages: hrStagesView,
      cards: hrCardsView,
      inline: hrInlineView,
      backlog: hrBacklogView,
      split: hrSplitView,
      calendar: hrCalendarView,
      dashboard: hrDashboardView,
  }),
  form: hrFullForm,
  forms: { full: hrFullForm, context: hrContextForm, mini: hrMiniForm, lookup: hrLookupForm },
  menu: hrMenu,
} as IRecordTypeDefinition;
